import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { brandName, differenceWith, differenceWithout, price, systemBenefits } from '../data/copy';
export function FinalCtaSection() {
  return <section className="w-full bg-slate-950 py-10 sm:py-14 [.chalk_&]:bg-slate-50" aria-labelledby="final-cta-heading" data-id="element-69" data-mp="3vscirzu6ospx">
      <div className="mx-auto max-w-4xl px-6" data-id="element-70" data-mp="2y5n9r612dfuk">
        <SectionHeading title={<span id="final-cta-heading" data-id="element-72" data-mp="333ykdiz6nudu">Your next youth basketball practice</span>} data-id="element-71" data-mp="2y2rbthp7ur64" />

        <div className="mt-8 grid overflow-hidden rounded-3xl border border-slate-800 md:grid-cols-2 [.chalk_&]:border-slate-200" data-id="element-73" data-mp="331m2f5tfdk0s">
          <div className="bg-slate-900 [.chalk_&]:bg-white" data-id="element-74" data-mp="3cua002s8bs0k">
            <h3 className="border-b border-slate-800 px-5 py-3.5 text-base font-bold uppercase tracking-wide text-slate-400 [.chalk_&]:border-slate-200 [.chalk_&]:text-slate-600" data-id="element-75" data-mp="3cvuqnhbfaqt5">
              Keep improvising
            </h3>
            <ul className="space-y-2 px-5 py-4" data-id="element-76" data-mp="2dbqlr3yzv1up">
              {differenceWithout.map(item => <li key={item} className="flex items-start gap-2 text-[0.92rem] leading-snug text-slate-400 [.chalk_&]:text-slate-600" data-id="element-77" data-mp="2ddur7qcjk8x3">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400 [.chalk_&]:text-red-600" strokeWidth={2.6} aria-hidden="true" data-id="element-78" data-mp="23lf5chy4j06x" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="border-t border-slate-800 bg-orange-400/[0.07] md:border-l md:border-t-0 [.chalk_&]:border-slate-200 [.chalk_&]:bg-orange-600/[0.07]" data-id="element-79" data-mp="1uma8dg27newv">
            <h3 className="border-b border-slate-800 px-5 py-3.5 text-base font-bold uppercase tracking-wide text-orange-400 [.chalk_&]:border-slate-200 [.chalk_&]:text-orange-600" data-id="element-80" data-mp="1kn2tupjqpe86">
              Or use {brandName}
            </h3>
            <ul className="space-y-2 px-5 py-4" data-id="element-81" data-mp="3f0avb0280o2s">
              {differenceWith.map(item => <li key={item} className="flex items-start gap-2 text-[0.92rem] font-medium leading-snug text-slate-50 [.chalk_&]:text-slate-900" data-id="element-82" data-mp="3a1r9r0rjheay">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-orange-400 [.chalk_&]:text-orange-600" strokeWidth={2.6} aria-hidden="true" data-id="element-83" data-mp="18bsett8kmn22" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-84" data-mp="13dquz63bmjpj">
          <p className="text-xl font-bold uppercase leading-tight tracking-tight text-slate-50 sm:text-2xl [.chalk_&]:text-slate-900" data-id="element-85" data-mp="13ea1lqnitlo9">
            You do not need to be the perfect basketball coach.
          </p>
          <p className="mt-3 text-lg text-slate-400 [.chalk_&]:text-slate-600" data-id="element-86" data-mp="1w0bmc6jsqvt3">
            You need a system that helps you:
          </p>
          <ul className="mx-auto mt-3 grid max-w-lg gap-x-6 gap-y-1.5 text-left sm:grid-cols-2" data-id="element-87" data-mp="1m3qgxk3v7ioq">
            {systemBenefits.map(item => <li key={item} className="flex items-start gap-2 text-[1.02rem] font-semibold text-slate-50 [.chalk_&]:text-slate-900" data-id="element-88" data-mp="6my9tu1j61gw">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-orange-400 [.chalk_&]:text-orange-600" strokeWidth={2.6} aria-hidden="true" data-id="element-89" data-mp="an06foses4pb" />
                {item}
              </li>)}
          </ul>

          <p className="mt-10 text-2xl font-extrabold uppercase leading-[1.05] tracking-tight text-orange-400 sm:text-4xl [.chalk_&]:text-orange-600" data-id="element-90" data-mp="3uehf1edswkli">
            Your next practice is already planned.
          </p>

          <CtaButton size="large" className="mt-7 w-full sm:w-auto" data-id="element-91" data-mp="3gkgqfdgkcdyv">
            Get {brandName} — {price}
          </CtaButton>
          <p className="mt-4 text-sm text-slate-400 [.chalk_&]:text-slate-600" data-id="element-92" data-mp="3bmoorrq49dhh">
            Secure payment · Instant access · 7-day guarantee
          </p>
        </div>
      </div>
    </section>;
}